<ng-container
  *ngIf="singlePackagingResource$ | async as singlePackagingResource"
>
  <ng-container *ngIf="packingListResource$ | async as packingListResource">
    <hazmatsuite-next-modal
      [title]="title"
      [showModal]="show"
      [confirmButtonLabel]="
        isDgSelectionMode ? '' : packingListResource['ButtonApply']
      "
      modalSize="xl"
      (closeModal)="cancel()"
      (confirm)="addPackage()"
    >
      <hazmatsuite-next-dangerousgood-selection
        *ngIf="isDgSelectionMode; else details"
        [showCancelButton]="true"
        [showLoadFromArticles]="showLoadFromArticles"
        [transportMode]="transportMode"
        [excludedDgClasses]="[7]"
        (selectDangerousGood)="
          selectDangerousGood(
            $event,
            singlePackagingResource['CannotLoadTogetherWith']
          )
        "
      ></hazmatsuite-next-dangerousgood-selection>

      <ng-template #details>
        <form [formGroup]="formGroup" *ngIf="formGroup">
          <lib-easydgd-single-package-form
            [singlePackagingModel]="model"
            defaultPackageType="1"
            [packageTypes]="packageTypes"
            [packagingUnCodes]="packagingUnCodes"
          ></lib-easydgd-single-package-form>
        </form>
      </ng-template>
    </hazmatsuite-next-modal>
  </ng-container>
</ng-container>
